import { Component, Input, Output, EventEmitter, OnInit, ElementRef, HostListener, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AdobeAnalyticsService} from './../../providers';

import { TabModel } from './tab.model';
import { EmitterService } from './emitter.service';

@Component({
  selector: 'app-tab',
  styleUrls: ['./tabs.component.scss'],
  providers: [AdobeAnalyticsService],
  templateUrl: './tab.component.html',
  encapsulation: ViewEncapsulation.None
})

export class TabComponent implements OnInit {

  @Input() option: TabModel;
  @Output() selectedTab: EventEmitter<TabModel>;

  constructor(protected router: Router, private el: ElementRef,private emitter: EmitterService, private adobeAnalyticsService: AdobeAnalyticsService) {
    this.selectedTab = new EventEmitter<TabModel>();
  }

  ngOnInit() {
  }

  selectTab(tab){
    this.adobeAnalyticsService.createClickProperties(tab.id,'Body','/businessconsole/learn');
    this.emitter.next(tab);
  }

}
